import { Component, HostListener, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-scroll-to-top',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss']
})
export class ScrollToTopComponent implements OnInit {

  isVisible = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { /* empty */ }

  ngOnInit(): void {
    // Initial check for scroll position
    if (isPlatformBrowser(this.platformId)) {
    this.checkScrollPosition();
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.checkScrollPosition();
    }
  }

  private checkScrollPosition(): void {
    // Show button when user scrolls down 300px from top
    if (isPlatformBrowser(this.platformId)) {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isVisible = scrollPosition > 300;
    }
  }

  scrollToTop(): void {
    // Smooth scroll to top
    if (isPlatformBrowser(this.platformId)) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    }
  }
}
